/**
 * @module common/components/modal/confirmation_dailog
 */
import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';

/**
 * Reusable confirmation dialog.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const ConfirmationDialog = ({ dialogVisible, dialogHeader, dialogTitle, dialogMessage,
                              submitAction, primaryActionText, toggleDialog,
                              secondaryActionText }) => {
  return (
      <ModalDialog
        dialogClasses='confirmation-dialog'
        contentClasses='confirmation-dialog'
        modalOpen={dialogVisible}
        closeAction={toggleDialog}
        modalHeader={dialogHeader}
        primaryClasses="btn btn-tertiary btn-block"
        onPrimary={submitAction}
        primaryLabel={primaryActionText || "Yes"}
        onSecondary={toggleDialog}
        secondaryLabel={secondaryActionText || "Cancel"}
      >
        <div className="dialog-message">
          { dialogTitle && <h2>{ dialogTitle }</h2> }
          { dialogMessage }
        </div>
      </ModalDialog>
  );
}

ConfirmationDialog.propTypes = {
  dialogHeader:         PropTypes.string,
  dialogTitle:          PropTypes.string,
  dialogMessage:        PropTypes.string,
  dialogVisible:        PropTypes.bool,
  toggleDialog:         PropTypes.func,
  submitAction:         PropTypes.func,
  primaryActionText:    PropTypes.string,
  secondaryActionText:  PropTypes.string,
};

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./common/components/modal/confirmation_dialog.jsx